// Responsive iframes (videos, embeds)
(function () {
    var iframes = document.querySelectorAll('.post-content iframe');
    iframes.forEach(function (iframe) {
        if (!iframe.parentElement.classList.contains('kg-video-card')) {
            var wrapper = document.createElement('div');
            wrapper.style.position = 'relative';
            wrapper.style.paddingBottom = '56.25%';
            wrapper.style.height = '0';
            wrapper.style.overflow = 'hidden';
            wrapper.style.maxWidth = '100%';
            wrapper.style.marginBottom = '1.5rem';
            iframe.parentElement.insertBefore(wrapper, iframe);
            wrapper.appendChild(iframe);
            iframe.style.position = 'absolute';
            iframe.style.top = '0';
            iframe.style.left = '0';
            iframe.style.width = '100%';
            iframe.style.height = '100%';
        }
    });
})();
